// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__vghhx","section":"home_section__ZSNWZ","color1":"home_color1__Ffh6h","color2":"home_color2__ztcOK"};